import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WellHubData, WellHubPageableResponse} from '@app-model/wellHub.model';
import { FilterOptions } from '@app-model/filter';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})

export class WellHubService {
  constructor(private http: HttpClient) {}

  paginate(filter: FilterOptions): Observable<WellHubPageableResponse> {
		return this.http.post(`${environment.api}/adminWellHub/list`, filter).pipe(map(
    (response: WellHubPageableResponse) => response));
	}

  getWellHub(id: number) {
    return this.http.get(`${environment.api}/adminWellHub/${id}`).pipe(
			map((response: WellHubData) => response),take(1)
		);
	}

  saveWellHub(wellHub: WellHubData): Observable<WellHubPageableResponse> {
		return this.http.post(`${environment.api}/adminWellHub/save`, wellHub)
    .pipe(map((response: WellHubPageableResponse) => response));
	}

  removeWellHub(wellHub: WellHubData): Observable<WellHubPageableResponse> {
		return this.http.delete(`${environment.api}/adminWellHub/${wellHub.id}`)
    .pipe(map((response: WellHubPageableResponse) => response));
	}
}
